module.exports = __webpack_public_path__ + "img/4.33e1823f.png";